import styles from "./SearchContainer.module.scss";
import { CloseOutlined } from "@ant-design/icons";
import classNames from "classnames";

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
  >
    <circle
      cx="22.449"
      cy="22.448"
      r="9.649"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
    />
    <path
      fill="currentColor"
      d="M33.282 34.13a.6.6 0 0 0 .849-.848l-.425.424-.424.424Zm-2.368-4.064-.424-.425-.848.849.424.424.424-.424.424-.424Zm2.792 3.64.425-.424-3.217-3.216-.424.424-.424.424 3.216 3.216.424-.424Z"
    />
  </svg>
);

export const VisualSimilarityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="48"
    fill="none"
    viewBox="0 0 56 48"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M32.11 18.523h.016"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      d="m15.675 29.48 6.847-6.848c1.27-1.223 2.837-1.223 4.108 0l2.97 2.97"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      d="M40.325 25.02v-7.182a6.163 6.163 0 0 0-6.162-6.163H21.837a6.163 6.163 0 0 0-6.163 6.163v12.325a6.163 6.163 0 0 0 6.163 6.163h6.936"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      d="M31.082 31.045a3.961 3.961 0 1 0 7.923 0 3.961 3.961 0 0 0-7.923 0Zm6.867 2.905 2.377 2.376"
    />
  </svg>
);

export const FiltersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="48"
    fill="none"
    viewBox="0 0 56 48"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M17.333 21.334a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0ZM20 13.333v5.333M20 24v10.667m10.61-5.877A2.666 2.666 0 1 0 28 32m0-18.667v13.333M28 32v2.667m5.333-17.333a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0ZM36 13.333v1.333M36 20v4m-2.667 9.333h8m-4-4v8"
    />
  </svg>
);

export const CloseIcon = ({
  className,
  onClick,
}: {
  onClick: (e: any) => void;
  className?: string;
}) => (
  <CloseOutlined
    data-testid="closeIcon"
    onClick={onClick}
    className={classNames(styles.closeIcon, className)}
  />
);

export const RecentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clip-path="url(#clip0_3012_1679)">
      <path
        d="M8.46216 5.6416V8.46231L9.87251 9.87266"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.15088 7.75714C2.3089 6.2058 3.03253 4.76693 4.18371 3.71505C5.33489 2.66318 6.83303 2.07194 8.3923 2.05413C9.95158 2.03632 11.4628 2.59319 12.6377 3.61849C13.8126 4.6438 14.5689 6.06576 14.7624 7.6131C14.9558 9.16043 14.5728 10.7248 13.6864 12.0078C12.8 13.2907 11.4723 14.2025 9.95667 14.569C8.44099 14.9356 6.84341 14.7313 5.46873 13.9952C4.09405 13.259 3.0385 12.0426 2.50347 10.5778M2.15088 14.1037V10.5778H5.67676"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3012_1679">
        <rect width="16.9242" height="16.9242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ImageUploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <g clip-path="url(#clip0_2546_22335)">
      <path
        d="M37.5 20H37.525"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.25 52.5H15C13.0109 52.5 11.1032 51.7098 9.6967 50.3033C8.29018 48.8968 7.5 46.9891 7.5 45V15C7.5 13.0109 8.29018 11.1032 9.6967 9.6967C11.1032 8.29018 13.0109 7.5 15 7.5H45C46.9891 7.5 48.8968 8.29018 50.3033 9.6967C51.7098 11.1032 52.5 13.0109 52.5 15V31.25"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 39.9996L20 27.4996C22.32 25.2671 25.18 25.2671 27.5 27.4996L36.25 36.2496"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35 35.0002L37.5 32.5002C39.1975 30.8677 41.1825 30.4277 43.035 31.1852"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.5 55V40"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M55 47.5L47.5 40L40 47.5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2546_22335">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const VisualSimilarityButtonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.981"
      d="M20.11 10.523h.016"
    />
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.407"
      d="m3.675 21.48 6.847-6.848c1.27-1.223 2.837-1.223 4.108 0l2.97 2.97"
    />
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.407"
      d="M28.326 17.02V9.838a6.163 6.163 0 0 0-6.163-6.163H9.837a6.163 6.163 0 0 0-6.163 6.163v12.325a6.163 6.163 0 0 0 6.163 6.163h6.936"
    />
    <path
      stroke="#EDEFF5"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.407"
      d="M19.082 23.045a3.961 3.961 0 1 0 7.923 0 3.961 3.961 0 0 0-7.923 0Zm6.867 2.905 2.377 2.376"
    />
  </svg>
);

export const VisualSimilarityModalIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0819 7.89209H15.0941"
      stroke="white"
      stroke-width="1.48563"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75586 16.1091L7.89137 10.9735C8.84452 10.0563 10.0195 10.0563 10.9727 10.9735C10.9727 10.9735 12.2195 12.2204 13.2004 13.2012"
      stroke="white"
      stroke-width="1.05529"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.2442 12.7646V7.37794C21.2442 6.15209 20.7572 4.97644 19.8904 4.10963C19.0236 3.24283 17.848 2.75586 16.6221 2.75586H7.37794C6.15209 2.75586 4.97644 3.24283 4.10963 4.10963C3.24283 4.97644 2.75586 6.15209 2.75586 7.37794V16.6221C2.75586 17.848 3.24283 19.0236 4.10963 19.8904C4.97644 20.7572 6.15209 21.2442 7.37794 21.2442H12.5802"
      stroke="white"
      stroke-width="1.05529"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3115 17.2833C14.3115 18.0713 14.6246 18.827 15.1818 19.3843C15.739 19.9415 16.4948 20.2545 17.2828 20.2545C18.0708 20.2545 18.8266 19.9415 19.3838 19.3843C19.941 18.827 20.254 18.0713 20.254 17.2833C20.254 16.4952 19.941 15.7395 19.3838 15.1823C18.8266 14.6251 18.0708 14.312 17.2828 14.312C16.4948 14.312 15.739 14.6251 15.1818 15.1823C14.6246 15.7395 14.3115 16.4952 14.3115 17.2833Z"
      stroke="white"
      stroke-width="1.05529"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.4615 19.4617L21.2443 21.2444"
      stroke="white"
      stroke-width="1.05529"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CropIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4820_28253)">
      <path
        d="M4.47327 2.40015V10.4001C4.47327 10.6123 4.56616 10.8158 4.73151 10.9658C4.89686 11.1159 5.12112 11.2001 5.35495 11.2001H14.1718"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.82825 4.80005H10.6451C10.879 4.80005 11.1032 4.88433 11.2686 5.03436C11.4339 5.18439 11.5268 5.38788 11.5268 5.60005V13.6001"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4820_28253">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExcludeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.8779 7.81595H14.8892"
      stroke="currentColor"
      stroke-width="1.71196"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.50853 2.5842H18.0167C18.8491 2.5842 19.6474 2.91487 20.236 3.50347C20.8247 4.09207 21.1553 4.89039 21.1553 5.7228V17.231M20.2598 20.4732C19.9678 20.7721 19.6189 21.0095 19.2336 21.1714C18.8484 21.3333 18.4346 21.4164 18.0167 21.4158H5.46233C4.62992 21.4158 3.83161 21.0851 3.243 20.4965C2.6544 19.9079 2.32373 19.1096 2.32373 18.2772V5.7228C2.32373 4.83876 2.68885 4.04051 3.27577 3.47033"
      stroke="currentColor"
      stroke-width="1.14131"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.32373 16.184L7.55473 10.953C8.5256 10.0188 9.72245 10.0188 10.6933 10.953L15.9243 16.184"
      stroke="currentColor"
      stroke-width="1.14131"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.269 12.3538C16.8696 12.2973 17.4774 12.5275 18.0162 13.0464L21.1548 16.185"
      stroke="currentColor"
      stroke-width="1.14131"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.32373 2.5842L21.1553 21.4158"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
